export default function useEllipsis(text: string, maxLength = 24) {
  if (text.length > maxLength) {
    const newText = text.substring(0, maxLength)
    return newText + '...'
  } else {
    return text
  }
}
